import * as ActionsTypes from "../../../common/state/StateConstants";
import { updateObject } from "../../../common/utils/FunctionsUtils";
const initialState = {
  error: null,
  errore: null,
  mfaErrorMessage: null,
  otpMailError: null,
  decisionError: null,
  isLoading: false,
  successMessage: null,
  demandes: [],
  isDemandesLoading: false,
  AllDemandes: [],
  isAllDemandesLoading: false,
  demandeDetail: [],
  demandeDocumentPdf: [],
  decisionType: [],
  uniteDouniere: [],
  uniteComplementaires: [],
  departments: [],
  searchDemandeObject: {
    modeConsultation: false,
    demandFDDto: {
      idNomenclature: null,
      numDfd: null,
      idType: null,
      idPaysOrigine: null,
      idEtat: null,
      fromDateCreation: null,
      toDateCreation: null,
      avis: null,
      importateur: null,
      importateurNom: null,
      nomenclatureNom: "",
      groupeId: null,
      imputee: null,
      numVisa: null,
    },
    pagination: {
      page: 0,
      pageSize: 10,
    },
  },
  expandedSearchForm: false,
  demandeDecisions: [],
  demandeDocuments: [],
  demandeMarchandises: [],
  categories: null,
  etats: null,
  paysOrigine: null,
  groupesContingent: null,
  nomenclatures: null,
  importateurs: null,
  token: null,
  qrCodeUrl: null,
  requireOTP: null,
  messageMfa: null,
  secret: null,
  isAuthenticated: false,
  isDecisionsLoading: false,
  isDocumentsLoading: false,
  isMarchandisesLoading: false,
  isHistoriqueLoading: false,
  historique: null,
  isDecisionMode: true,
  nomenclatureDate: null,
  selectedDepartements: null,
  isDownloadLoading: false,
  isDecisionLoading: false,
  isDecisionVisible: false,
  fixedDecision: null,
  columnsState: {
    categorie: true,
    importateur: true,
    dateSoumission: true,
    avis: true,
    bureauD: true,
    marchandise: true,
    nomenclature: true,
    numDecision: true,
    etat: true,
  },
  density: "standard",
  drawer: { open: true, width: 260 },
  isEtatTableLoading: false,
  passwordChangeSuccessMassage: null,
  passwordChangeError: null,
  kpi: null,
};

/*--------------------------------------------------GET-CHARGES----------------------------------------------------*/

export const setDFDLoading = (state, action) => {
  return updateObject(state, {
    isDemandesLoading: action.data,
  });
};

const searchDemandes = (state, action) => {
  return updateObject(state, {
    error: null,
    searchDemandeObject: action.searchObject,
    expandedSearchForm: action.expanded,
    isDemandesLoading: true,
  });
};

const searchDemandesSuccess = (state, action) => {
  return updateObject(state, {
    demandes: action.data,
    isDemandesLoading: false,
  });
};

const searchDemandesFailure = (state, action) => {
  return updateObject(state, { error: action.error, isDemandesLoading: false });
};

const searchAllDemandes = (state) => {
  return updateObject(state, { error: null, isAllDemandesLoading: true });
};

const searchAllDemandesSuccess = (state, action) => {
  return updateObject(state, {
    AllDemandes: action.data,
    isAllDemandesLoading: false,
  });
};

const searchAllDemandesFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isAllDemandesLoading: false,
  });
};

const fetchHistorique = (state, action) => {
  return updateObject(state, {
    error: null,
    historique: null,
    isHistoriqueLoading: true,
  });
};

const fetchHistoriqueSuccess = (state, action) => {
  return updateObject(state, {
    historique: action.data,
    isHistoriqueLoading: false,
  });
};

const fetchHistoriqueFailure = (state, action) => {
  return updateObject(state, {
    historique: null,
    error: action.error,
    isHistoriqueLoading: false,
  });
};

const clearHistorique = (state) => {
  return updateObject(state, {
    historique: null,
  });
};

const updateSearchForm = (state, action) => {
  return updateObject(state, {
    searchDemandeObject: action.searchObject,
    expandedSearchForm: true,
    isDemandesLoading: true,
  });
};

const clearSearchForm = (state) => {
  return updateObject(state, {
    searchDemandeObject: {
      modeConsultation: false,
      demandFDDto: {
        idNomenclature: null,
        numDfd: null,
        idType: null,
        idPaysOrigine: null,
        idEtat: null,
        fromDateCreation: null,
        toDateCreation: null,
        avis: null,
        importateur: null,
        importateurNom: null,
        nomenclatureNom: "",
        groupeId: null,
        imputee: null,
        numVisa: null,
      },
      pagination: {
        page: 0,
        pageSize: 10,
      },
    },
    demandes: [],
    AllDemandes: [],
    expandedSearchForm: false,
  });
};

const authenticate = (state, action) => {
  return updateObject(state, { error: null, isLoading: true });
};

const authenticateSuccess = (state, action) => {
  const updateData = { 
    qrCodeUrl: action.data.qrCodeUrl, 
    secret: action.data.secret,
    requireOTP: action.data.requireOTP,
    messageMfa: action.data.message,
    isLoading: false 
  };

  if (action.data.token) {
    updateData.token = action.data.token;
  }
  
  return updateObject(state, updateData);

};

const authenticateFailure = (state, action) => {
  return updateObject(state, { error: action.error, isLoading: false });
};

const setIsAuthenticated = (state, action) => {
  if (!action.data) {
    return updateObject(state, {
      isAuthenticated: action.data,
      qrCodeUrl: null,
      token: null,
    });
  } else {
    return updateObject(state, {
      isAuthenticated: action.data,
    });
  }
};

const getCategories = (state) => {
  return updateObject(state, { error: null, isLoading: true });
};

const getCategoriesSuccess = (state, action) => {
  return updateObject(state, { categories: action.data, isLoading: false });
};

const getCategoriesFailure = (state, action) => {
  return updateObject(state, { error: action.error, isLoading: false });
};

const getPaysOrigine = (state) => {
  return updateObject(state, { error: null, isLoading: true });
};

const getPaysOrigineSuccess = (state, action) => {
  return updateObject(state, { paysOrigine: action.data, isLoading: false });
};

const getPaysOrigineFailure = (state, action) => {
  return updateObject(state, { error: action.error, isLoading: false });
};

const registerMFA = (state, action) => {
  return updateObject(state, { mfaErrorMessage: null, isLoading: true });
};

const registerMFASuccess = (state, action) => {
  return updateObject(state, 
    { 
      token: action.data?.token, 
      isLoading: false 
    }
  );
};

const registerMFAFailure = (state, action) => {
  return updateObject(state, { mfaErrorMessage: action.error, isLoading: false });
};

const sendOtpMail = (state, action) => {
  return updateObject(state, { otpMailError: null, isLoading: true });
};

const sendOtpMailSuccess = (state, action) => {
  return updateObject(state, 
    { 
      messageMfa: action.data.message,
      isLoading: false 
    }
  );
};

const sendOtpMailFailure = (state, action) => {
  return updateObject(state, { otpMailError: action.error, isLoading: false });
};

const getEtats = (state) => {
  return updateObject(state, { error: null, isLoading: true });
};

const getEtatsSuccess = (state, action) => {
  return updateObject(state, { etats: action.data, isLoading: false });
};

const getEtatsFailure = (state, action) => {
  return updateObject(state, { error: action.error, isLoading: false });
};

const getGroupesContingent = (state) => {
  return updateObject(state, { error: null, isLoading: true });
};

const getGroupesContingentSuccess = (state, action) => {
  return updateObject(state, {
    groupesContingent: action.data,
    isLoading: false,
  });
};

const getGroupesContingentFailure = (state, action) => {
  return updateObject(state, { error: action.error, isLoading: false });
};

const getNomenclatures = (state) => {
  return updateObject(state, { error: null, isLoading: true });
};

const getNomenclaturesSuccess = (state, action) => {
  return updateObject(state, {
    nomenclatures: action.data,
    isLoading: false,
  });
};

const getNomenclaturesFailure = (state, action) => {
  return updateObject(state, { error: action.error, isLoading: false });
};

const getImportateurs = (state) => {
  return updateObject(state, { error: null, isLoading: true });
};

const getImportateursSuccess = (state, action) => {
  return updateObject(state, {
    importateurs: action.data,
    isLoading: false,
  });
};

const getImportateursFailure = (state, action) => {
  return updateObject(state, { error: action.error, isLoading: false });
};

const getDfd = (state) => {
  return updateObject(state, {
    successMessage: null,
    error: null,
    isLoading: true,
  });
};

const getDfdSuccess = (state, action) => {
  return updateObject(state, {
    demandeDetail: action.data,
    isLoading: false,
  });
};

const getDfdFailure = (state, action) => {
  return updateObject(state, { error: action.error, isLoading: false });
};

const getDfdDecisions = (state) => {
  return updateObject(state, { error: null, isDecisionsLoading: true });
};

const getDfdDecisionsSuccess = (state, action) => {
  return updateObject(state, {
    demandeDecisions: action.data,
    isDecisionsLoading: false,
  });
};

const getDfdDecisionsFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isDecisionsLoading: false,
  });
};

const getDfdDocuments = (state) => {
  return updateObject(state, { error: null, isDocumentsLoading: true });
};

const getDfdDocumentsSuccess = (state, action) => {
  return updateObject(state, {
    demandeDocuments: action.data,
    isDocumentsLoading: false,
  });
};

const getDfdDocumentsFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isDocumentsLoading: false,
  });
};

const getDfdMarchandises = (state) => {
  return updateObject(state, { error: null, isMarchandisesLoading: true });
};

const getDfdMarchandisesSuccess = (state, action) => {
  return updateObject(state, {
    demandeMarchandises: action.data,
    isMarchandisesLoading: false,
  });
};

const getDfdMarchandisesFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isMarchandisesLoading: false,
  });
};

const downloadDemandeDocument = (state) => {
  return updateObject(state, {
    errore: null,
    demandeDocumentPdf: null,
    isDownloadLoading: true,
  });
};

const downloadDemandeDocumentSuccess = (state, action) => {
  return updateObject(state, {
    demandeDocumentPdf: action.data === "DOWNLOAD" ? null : action.data,
    error: null,
    isDownloadLoading: false,
  });
};

const downloadDemandeDocumentFailure = (state, action) => {
  return updateObject(state, {
    errore: action?.error,
    isDownloadLoading: false,
  });
};

const downloadDemande = (state) => {
  return updateObject(state, {
    errore: null,
    isDownloadLoading: true,
  });
};

const downloadDemandeSuccess = (state, action) => {
  return updateObject(state, {
    errore: null,
    isDownloadLoading: false,
  });
};

const downloadDemandeFailure = (state, action) => {
  return updateObject(state, {
    errore: action?.error,
    isDownloadLoading: false,
  });
};

const getDecisionType = (state) => {
  return updateObject(state, {
    error: null,
    isLoading: true,
  });
};

const getDecisionTypeSuccess = (state, action) => {
  return updateObject(state, {
    decisionType: action.data,
    isLoading: false,
  });
};

const getDecisionTypeFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isLoading: false,
  });
};

const getUniteDouniere = (state) => {
  return updateObject(state, {
    error: null,
    isLoading: false,
  });
};

const getUniteDouniereSuccess = (state, action) => {
  return updateObject(state, {
    uniteDouniere: action.data,
    isLoading: false,
  });
};

const getUniteDouniereFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isLoading: false,
  });
};

const getUniteComp = (state) => {
  return updateObject(state, {
    error: null,
    isLoading: false,
  });
};

const getUniteCompSuccess = (state, action) => {
  return updateObject(state, {
    uniteComplementaires: action.data,
    isLoading: false,
  });
};

const getUniteCompFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isLoading: false,
  });
};

const getDepartments = (state) => {
  return updateObject(state, {
    error: null,
    isLoading: false,
  });
};

const getDepartmentsSuccess = (state, action) => {
  return updateObject(state, {
    departments: action.data,
    isLoading: false,
  });
};

const getDepartmentsFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    isLoading: false,
  });
};

const DecisionMceDfd = (state) => {
  return updateObject(state, {
    errore: null,
    isDecisionLoading: true,
    successMessage: null,
  });
};

const DecisionMceDfdSuccess = (state, action) => {
  return updateObject(state, {
    successMessage: "Décision envoyée avec success",
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const DecisionMceDfdFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isDecisionVisible: true,
    isDecisionLoading: false,
  });
};

const DecisionDepDfd = (state) => {
  return updateObject(state, {
    errore: null,
    isDecisionLoading: true,
    successMessage: null,
  });
};

const DecisionDepDfdSuccess = (state, action) => {
  return updateObject(state, {
    successMessage: action.data.content,
    isDecisionLoading: false,
    isLoading: false,
  });
};

const DecisionDepDfdFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isDecisionLoading: false,
    isLoading: false,
  });
};

const transferDfd = (state) => {
  return updateObject(state, {
    errore: null,
    isDecisionLoading: true,
    successMessage: null,
  });
};

const transferDfdSuccess = (state, action) => {
  return updateObject(state, {
    successMessage: action.data.content,
    isDecisionVisible: false,
    isDecisionLoading: false,
  });
};

const transferDfdFailure = (state, action) => {
  return updateObject(state, {
    errore: action.error,
    isDecisionVisible: true,
    isDecisionLoading: false,
  });
};

const setIsDecisionMode = (state, action) => {
  return updateObject(state, {
    isDecisionMode: action.data,
  });
};

const setIsDecisionVisible = (state, action) => {
  return updateObject(state, {
    isDecisionVisible: action.data,
  });
};

const getFixedDfdDecision = (state) => {
  return updateObject(state, {
    error: null,
    isLoading: true,
  });
};

const getFixedDfdDecisionSuccess = (state, action) => {
  return updateObject(state, {
    fixedDecision: action.data,
    isLoading: false,
  });
};

const getFixedDfdDecisionFailure = (state, action) => {
  return updateObject(state, {
    error: action.error,
    fixedDecision: null,
    isLoading: false,
  });
};

const getNomenclaturesGroupe = (state) => {
  return updateObject(state, { error: null, isLoading: true });
};

const getNomenclaturesGroupeSuccess = (state, action) => {
  return updateObject(state, {
    nomenclatureDate: action.data,
    isLoading: false,
  });
};

const getNomenclaturesGroupeFailure = (state, action) => {
  return updateObject(state, {
    errore: action?.error,
    isLoading: false,
  });
};

const getSelectedDepartments = (state) => {
  return updateObject(state, {
    error: null,
    selectedDepartements: null,
    isLoading: true,
  });
};

const getSelectedDepartmentsSuccess = (state, action) => {
  return updateObject(state, {
    selectedDepartements: action.data,
    isLoading: false,
  });
};

const getSelectedDepartmentsFailure = (state, action) => {
  return updateObject(state, { error: action.error, isLoading: false });
};

const setDFDColumnsDensityState = (state, action) => {
  return updateObject(state, {
    columnsState: action.data.columnsState,
    density: action.data.density,
  });
};

const getDFDColumnsDensityState = (state) => {
  return updateObject(state, {
    isEtatTableLoading: true,
  });
};

const getDFDColumnsDensityStateSuccess = (state, action) => {
  const baseUpdate = { isEtatTableLoading: false };

  if (!action.data || action.data.id == null) {
    return updateObject(state, baseUpdate);
  }

  return updateObject(state, {
    ...baseUpdate,
    columnsState: action.data.columnsState,
    density: action.data.density,
  });
};

const getDFDColumnsDensityStateFailure = (state, action) => {
  return updateObject(state, {
    isEtatTableLoading: false,
  });
};

const postChangePassword = (state) => {
  return updateObject(state, {
    passwordChangeError: null,
    passwordChangeSuccessMassage: null,
    isLoading: true,
  });
};

const postChangePasswordSuccess = (state, action) => {
  return updateObject(state, {
    passwordChangeSuccessMassage: action.data,
    isLoading: false,
  });
};

const postChangePasswordFailure = (state, action) => {
  return updateObject(state, {
    passwordChangeError: action.error,
    isLoading: false,
  });
};

const clearDemandeDetails = (state) => {
  return updateObject(state, {
    demandeDetail: [],
    demandeDocumentPdf: null,
    successMessage: null,
    nomenclatureDate: null,
    errore: null,
    selectedDepartements: null,
  });
};

const clearPasswordChange = (state) => {
  return updateObject(state, {
    passwordChangeError: null,
    passwordChangeSuccessMassage: null,
  });
};

const resetError = (state, action) => {
  return updateObject(state, { error: null });
};

const resetState = (state) => {
  return updateObject(state, initialState);
};

const fetchKpiDfd = (state, action) => {
  return updateObject(state, {
    error: null,
    kpi: null,
    isLoading: true,
  });
};

const fetchKpiDfdSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    kpi: action.data,
    isLoading: false,
  });
};

const fetchKpiDfdFailure = (state, action) => {
  return updateObject(state, {
    errore: action?.error,
    kpi: null,
    isLoading: false,
  });
};

const updateDfdDateFinValidite = (state, action) => {
  return updateObject(state, {
    error: null,
    errore: null,
    isLoading: true,
    successMessage: null,
  });
};

const updateDfdDateFinValiditeSuccess = (state, action) => {
  return updateObject(state, {
    successMessage: "Date fin validité changé avec success",
    error: null,
    errore: null,
    isLoading: false,
  });
};

const updateDfdDateFinValiditeFailure = (state, action) => {
  return updateObject(state, {
    errore: action?.error,
    isLoading: false,
    successMessage: null,
  });
};

export const setDrawerState = (state, action) => {
  return updateObject(state, {
    drawer: action.data,
  });
};

export const DfdReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionsTypes.SEARCH_DEMANDE:
      return searchDemandes(state, action);
    case ActionsTypes.SEARCH_DEMANDE_SUCCESS:
      return searchDemandesSuccess(state, action);
    case ActionsTypes.SEARCH_DEMANDE_FAIL:
      return searchDemandesFailure(state, action);
    case ActionsTypes.SEARCH_ALL_DEMANDES:
      return searchAllDemandes(state, action);
    case ActionsTypes.SEARCH_ALL_DEMANDES_SUCCESS:
      return searchAllDemandesSuccess(state, action);
    case ActionsTypes.SEARCH_ALL_DEMANDES_FAILURE:
      return searchAllDemandesFailure(state, action);
    case ActionsTypes.FETCH_CATEGORIES:
      return getCategories(state);
    case ActionsTypes.FETCH_CATEGORIES_SUCCESS:
      return getCategoriesSuccess(state, action);
    case ActionsTypes.FETCH_CATEGORIES_FAILURE:
      return getCategoriesFailure(state, action);
    case ActionsTypes.FETCH_ETATS:
      return getEtats(state);
    case ActionsTypes.FETCH_ETATS_SUCCESS:
      return getEtatsSuccess(state, action);
    case ActionsTypes.FETCH_ETATS_FAILURE:
      return getEtatsFailure(state, action);
    case ActionsTypes.FETCH_GROUPES_CONTINGENT:
      return getGroupesContingent(state);
    case ActionsTypes.FETCH_PAYS_ORIGINE:
      return getPaysOrigine(state);
    case ActionsTypes.FETCH_PAYS_ORIGINE_SUCCESS:
      return getPaysOrigineSuccess(state, action);
    case ActionsTypes.FETCH_PAYS_ORIGINE_FAILURE:
      return getPaysOrigineFailure(state, action);
    case ActionsTypes.FETCH_GROUPES_CONTINGENT_SUCCESS:
      return getGroupesContingentSuccess(state, action);
    case ActionsTypes.FETCH_GROUPES_CONTINGENT_FAILURE:
      return getGroupesContingentFailure(state, action);
    case ActionsTypes.FETCH_NOMENCLATURES:
      return getNomenclatures(state);
    case ActionsTypes.FETCH_NOMENCLATURES_SUCCESS:
      return getNomenclaturesSuccess(state, action);
    case ActionsTypes.FETCH_NOMENCLATURES_FAILURE:
      return getNomenclaturesFailure(state, action);
    case ActionsTypes.FETCH_IMPORTATEURS:
      return getImportateurs(state);
    case ActionsTypes.FETCH_IMPORTATEURS_SUCCESS:
      return getImportateursSuccess(state, action);
    case ActionsTypes.FETCH_IMPORTATEURS_FAILURE:
      return getImportateursFailure(state, action);
    case ActionsTypes.FETCH_DFD:
      return getDfd(state);
    case ActionsTypes.FETCH_DFD_SUCCESS:
      return getDfdSuccess(state, action);
    case ActionsTypes.FETCH_DFD_FAILURE:
      return getDfdFailure(state, action);
    case ActionsTypes.FETCH_DFD_DECISIONS:
      return getDfdDecisions(state);
    case ActionsTypes.FETCH_DFD_DECISIONS_SUCCESS:
      return getDfdDecisionsSuccess(state, action);
    case ActionsTypes.FETCH_DFD_DECISIONS_FAILURE:
      return getDfdDecisionsFailure(state, action);
    case ActionsTypes.FETCH_DFD_DOCUMENTS:
      return getDfdDocuments(state);
    case ActionsTypes.FETCH_DFD_DOCUMENTS_SUCCESS:
      return getDfdDocumentsSuccess(state, action);
    case ActionsTypes.FETCH_DFD_DOCUMENTS_FAILURE:
      return getDfdDocumentsFailure(state, action);
    case ActionsTypes.FETCH_DFD_MARCHANDISES:
      return getDfdMarchandises(state);
    case ActionsTypes.FETCH_DFD_MARCHANDISES_SUCCESS:
      return getDfdMarchandisesSuccess(state, action);
    case ActionsTypes.FETCH_DFD_MARCHANDISES_FAILURE:
      return getDfdMarchandisesFailure(state, action);
    case ActionsTypes.DOWNLOAD_DEMAND_DOCUMENT:
      return downloadDemandeDocument(state);
    case ActionsTypes.DOWNLOAD_DEMAND_DOCUMENT_SUCCESS:
      return downloadDemandeDocumentSuccess(state, action);
    case ActionsTypes.DOWNLOAD_DEMAND_DOCUMENT_FAILURE:
      return downloadDemandeDocumentFailure(state, action);
    case ActionsTypes.DOWNLOAD_DEMAND:
      return downloadDemande(state);
    case ActionsTypes.DOWNLOAD_DEMAND_SUCCESS:
      return downloadDemandeSuccess(state, action);
    case ActionsTypes.DOWNLOAD_DEMAND_FAILURE:
      return downloadDemandeFailure(state, action);

    case ActionsTypes.FETCH_TYPE_DECISION:
      return getDecisionType(state);
    case ActionsTypes.FETCH_TYPE_DECISION_SUCCESS:
      return getDecisionTypeSuccess(state, action);
    case ActionsTypes.FETCH_TYPE_DECISION_FAILURE:
      return getDecisionTypeFailure(state, action);
    case ActionsTypes.FETCH_TYPE_DOUNIERE:
      return getUniteDouniere(state);
    case ActionsTypes.FETCH_TYPE_DOUNIERE_SUCCESS:
      return getUniteDouniereSuccess(state, action);
    case ActionsTypes.FETCH_TYPE_DOUNIERE_FAILURE:
      return getUniteDouniereFailure(state, action);
    case ActionsTypes.FETCH_UNIT_COMP:
      return getUniteComp(state);
    case ActionsTypes.FETCH_UNIT_COMP_SUCCESS:
      return getUniteCompSuccess(state, action);
    case ActionsTypes.FETCH_UNIT_COMP_FAILURE:
      return getUniteCompFailure(state, action);
    case ActionsTypes.FETCH_DEPARTMENTS:
      return getDepartments(state);
    case ActionsTypes.FETCH_DEPARTMENTS_SUCCESS:
      return getDepartmentsSuccess(state, action);
    case ActionsTypes.FETCH_DEPARTMENTS_FAILURE:
      return getDepartmentsFailure(state, action);
    case ActionsTypes.DECISION_MCE_DFD:
      return DecisionMceDfd(state);
    case ActionsTypes.DECISION_MCE_DFD_SUCCESS:
      return DecisionMceDfdSuccess(state, action);
    case ActionsTypes.DECISION_MCE_DFD_FAILURE:
      return DecisionMceDfdFailure(state, action);
    case ActionsTypes.DECISION_DEP_DFD:
      return DecisionDepDfd(state);
    case ActionsTypes.DECISION_DEP_DFD_SUCCESS:
      return DecisionDepDfdSuccess(state, action);
    case ActionsTypes.DECISION_DEP_DFD_FAILURE:
      return DecisionDepDfdFailure(state, action);
    case ActionsTypes.TRANSFER_DFD:
      return transferDfd(state);
    case ActionsTypes.TRANSFER_DFD_SUCCESS:
      return transferDfdSuccess(state, action);
    case ActionsTypes.TRANSFER_DFD_FAILURE:
      return transferDfdFailure(state, action);
    case ActionsTypes.SET_DECISION_MODE:
      return setIsDecisionMode(state, action);
    case ActionsTypes.SET_DECISION_VISIBLE:
      return setIsDecisionVisible(state, action);
    case ActionsTypes.GET_FIXED_DFD_DECISION:
      return getFixedDfdDecision(state);
    case ActionsTypes.GET_FIXED_DFD_DECISION_SUCCESS:
      return getFixedDfdDecisionSuccess(state, action);
    case ActionsTypes.GET_FIXED_DFD_DECISION_FAILURE:
      return getFixedDfdDecisionFailure(state, action);
    case ActionsTypes.FETCH_NOMENCLATURES_GROUP:
      return getNomenclaturesGroupe(state, action);
    case ActionsTypes.FETCH_NOMENCLATURES_GROUP_SUCCESS:
      return getNomenclaturesGroupeSuccess(state, action);
    case ActionsTypes.FETCH_NOMENCLATURES_GROUP_FAILURE:
      return getNomenclaturesGroupeFailure(state, action);
    case ActionsTypes.SELECTED_DEPARTMENT:
      return getSelectedDepartments(state);
    case ActionsTypes.SELECTED_DEPARTMENT_SUCCESS:
      return getSelectedDepartmentsSuccess(state, action);
    case ActionsTypes.SELECTED_DEPARTMENT_FAILURE:
      return getSelectedDepartmentsFailure(state, action);
    case ActionsTypes.CLEAR_DEMANDE_DETIALS:
      return clearDemandeDetails(state);
    case ActionsTypes.UPDATE_SEARCH_FORM:
      return updateSearchForm(state, action);
    case ActionsTypes.CLEAR_SEARCH_FORM:
      return clearSearchForm(state);
    case ActionsTypes.CLEAR_HISTORIQUE_DFD:
      return clearHistorique(state);
    case ActionsTypes.RESET_STATE:
      return resetState(state);
    case ActionsTypes.RESET_ERROR:
      return resetError(state, action);
    case ActionsTypes.FETCH_HISTORIQUE_DFD:
      return fetchHistorique(state, action);
    case ActionsTypes.FETCH_HISTORIQUE_DFD_SUCCESS:
      return fetchHistoriqueSuccess(state, action);
    case ActionsTypes.FETCH_HISTORIQUE_DFD_FAILURE:
      return fetchHistoriqueFailure(state, action);
    case ActionsTypes.SET_DFD_COLUMNS_DENSITY_STATE:
      return setDFDColumnsDensityState(state, action);
    case ActionsTypes.GET_DFD_COLUMNS_DENSITY_STATE:
      return getDFDColumnsDensityState(state, action);
    case ActionsTypes.GET_DFD_COLUMNS_DENSITY_STATE_SUCCESS:
      return getDFDColumnsDensityStateSuccess(state, action);
    case ActionsTypes.GET_DFD_COLUMNS_DENSITY_STATE_FAILURE:
      return getDFDColumnsDensityStateFailure(state, action);
    case ActionsTypes.DFD_KPI:
      return fetchKpiDfd(state, action);
    case ActionsTypes.DFD_KPI_SUCCESS:
      return fetchKpiDfdSuccess(state, action);
    case ActionsTypes.DFD_KPI_FAILURE:
      return fetchKpiDfdFailure(state, action);
    case ActionsTypes.SET_DRAWER_STATE:
      return setDrawerState(state, action);
    default:
      return state;
  }
};

export const AuthentificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionsTypes.REGISTER_MFA:
      return registerMFA(state, action);
    case ActionsTypes.REGISTER_MFA_SUCCESS:
      return registerMFASuccess(state, action);
    case ActionsTypes.REGISTER_MFA_FAILURE:
      return registerMFAFailure(state, action);  
    case ActionsTypes.SEND_OTP_MAIL:
      return sendOtpMail(state, action);
    case ActionsTypes.SEND_OTP_MAIL_SUCCESS:
      return sendOtpMailSuccess(state, action);
    case ActionsTypes.SEND_OTP_MAIL_FAILURE:
      return sendOtpMailFailure(state, action);    
    case ActionsTypes.AUTHENTICATE_USER:
      return authenticate(state, action);
    case ActionsTypes.AUTHENTICATE_USER_SUCCESS:
      return authenticateSuccess(state, action);
    case ActionsTypes.AUTHENTICATE_USER_FAILURE:
      return authenticateFailure(state, action);
    case ActionsTypes.SET_IS_AUTHENTICATED:
      return setIsAuthenticated(state, action);
    case ActionsTypes.RESET_ERROR:
      return resetError(state, action);
    case ActionsTypes.POST_CHANGE_PASSWORD:
      return postChangePassword(state);
    case ActionsTypes.POST_CHANGE_PASSWORD_SUCCESS:
      return postChangePasswordSuccess(state, action);
    case ActionsTypes.POST_CHANGE_PASSWORD_FAILURE:
      return postChangePasswordFailure(state, action);
    case ActionsTypes.CLEAR_CHANGE_PASSWORD:
      return clearPasswordChange(state);
    case ActionsTypes.SET_DFD_LOADING:
      return setDFDLoading(state, action);
    case ActionsTypes.UPDATE_DFD_DATE_FIN_VALIDITE:
      return updateDfdDateFinValidite(state, action);
    case ActionsTypes.UPDATE_DFD_DATE_FIN_VALIDITE_SUCCESS:
      return updateDfdDateFinValiditeSuccess(state, action);
    case ActionsTypes.UPDATE_DFD_DATE_FIN_VALIDITE_FAILURE:
      return updateDfdDateFinValiditeFailure(state, action);
    default:
      return state;
  }
};
